"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgCloudDrizzle = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M25 32a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm-4-2a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm8 0a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm-4-4a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm-2.5-13.985A9 9 0 0130.48 18H31a6 6 0 012.4 11.496 1 1 0 01-.802-1.832A4 4 0 0031 20h-1.26a1 1 0 01-.968-.75 7 7 0 10-11.148 7.219 1 1 0 01-1.248 1.562A9 9 0 0122.5 12.015zM21 24a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm8 0a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1z",
    id: "cloud-drizzle_svg__a"
  }));
};

var _default = SvgCloudDrizzle;
exports.default = _default;